import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface TerminContactChoiceData {
  /** Auftrag (order) mit root_order.person, order_number etc. */
  order: any;
  /** Startdatum des Termins (Date oder ISO-String) */
  startDate: Date | string;
  /** Enddatum des Termins (Date oder ISO-String) */
  endDate: Date | string;
  /** Optional: Name des Teams/Filiale */
  teamName?: string;
}

export type TerminContactChoiceResult = 'email' | 'call' | null;

@Component({
  selector: 'app-termin-contact-choice-dialog',
  templateUrl: './termin-contact-choice-dialog.component.html',
  styleUrls: ['./termin-contact-choice-dialog.component.css']
})
export class TerminContactChoiceDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<TerminContactChoiceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TerminContactChoiceData
  ) {}

  get orderNumber(): string {
    const o = this.data?.order;
    return o?.order_number ?? o?.root_order?.order_number ?? o?.id ?? '–';
  }

  get dateLabel(): string {
    const start = this.data?.startDate;
    if (!start) return '–';
    const d = typeof start === 'string' ? new Date(start.replace(' ', 'T')) : new Date(start);
    return d.toLocaleDateString('de-DE', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' });
  }

  get timeLabel(): string {
    const start = this.data?.startDate;
    const end = this.data?.endDate;
    if (!start) return '–';
    const s = typeof start === 'string' ? new Date(start.replace(' ', 'T')) : new Date(start);
    const timeStart = s.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
    if (!end) return timeStart;
    const e = typeof end === 'string' ? new Date(end.replace(' ', 'T')) : new Date(end);
    const timeEnd = e.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
    return timeStart + ' – ' + timeEnd;
  }

  chooseEmail(): void {
    this.dialogRef.close('email' as TerminContactChoiceResult);
  }

  chooseCall(): void {
    this.dialogRef.close('call' as TerminContactChoiceResult);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
